import { Table } from "antd";
import React from "react";

const AntTable = Table;
export default AntTable;
